// extracted by mini-css-extract-plugin
module.exports = {"message":"PlainMessage_message__o5wV6","leftMargin":"PlainMessage_leftMargin__ykBhQ","rightMargin":"PlainMessage_rightMargin__V1B2b"};